// extracted by mini-css-extract-plugin
module.exports = {"pageLoaderWrapper":"PageLoader_pageLoaderWrapper__0QMuD","kf-page-loader-spin":"PageLoader_kf-page-loader-spin__cHGmF"};